module.exports = __webpack_public_path__ + "img/m_copyright.b0c2607f.png";